import { css } from '@emotion/react';
import { ButtonKind, SpacingToken } from '@livechat/design-system-react-components';

export const goToProductButton = (kind: ButtonKind) => css`
  margin-top: var(${kind === 'primary' ? SpacingToken.Spacing3 : SpacingToken.Spacing0});
  margin-bottom: var(${kind === 'primary' ? SpacingToken.Spacing3 : SpacingToken.Spacing0});

  > div {
    display: flex;
    align-items: center;
  }
`;

export const goToProductButtonText = (withIcon: boolean) => css`
  margin: 0 0 0 ${withIcon ? '6px' : 0};
`;
